export default __webpack_public_path__ + "static/media/UK.e3962cd0.svg";